// src/Result.js
import './asset/App.css';
import React from 'react';

const Result = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const auth = queryParameters.get("auth");
    const confirm = queryParameters.get("confirm");

    if(!auth || !confirm){
      return (
        <div className="App">
            <h2>聯結有誤</h2>
            <p>請重新確認連結，或是聯繫公司</p>
        </div>
      );
    }

    fetch('https://macct.tw/api/form/confirm', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'credentials': 'include'
        },
        body: JSON.stringify({auth:auth,confirm:confirm}),
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if(data.success){
          //alert("勞報單創建成功");
        }else{
          alert("勞報單確認失敗 \n \n",data.message);
        }
      })
      .catch(error => {
        console.error('Error:', error);
    });

    if(confirm == "yes"){
      return (
        <div className="App">
            <h2>勞報單確認完畢</h2>
            <p>勞報單已經成立並通知對方公司，您可以關閉此頁面</p>
        </div>
      );
    }else if(confirm == "no"){
      return (
        <div className="App">
            <h2>勞報單作廢成功</h2>
            <p>勞報單已經作廢並通知對方公司，您可以關閉此頁面</p>
        </div>
      );
    }else{
      return (
        <div className="App">
            <h2>聯結有誤</h2>
            <p>請重新確認連結，或是聯繫公司</p>
        </div>
      );
    }

};

export default Result;